(() => {
  const rootSelector = '[data-armor-community-v2]';
  const states = new WeakMap();

  function rootsWithin(scope) {
    const roots = [];
    if (scope instanceof Element && scope.hasAttribute('data-armor-community-v2')) roots.push(scope);
    if (scope && typeof scope.querySelectorAll === 'function') {
      roots.push(...scope.querySelectorAll(rootSelector));
    }
    return [...new Set(roots)];
  }

  function init(root) {
    if (!(root instanceof Element) || states.has(root)) return;
    const controls = root.querySelector('[data-armor-community-controls]');
    const filter = root.querySelector('[data-armor-community-filter]');
    const status = root.querySelector('[data-armor-community-status]');
    const cards = [...root.querySelectorAll('[data-community-story]')];
    if (!controls || !filter || !status || cards.length === 0) return;

    filter.querySelectorAll('[data-event-option]').forEach((option) => option.remove());
    const events = new Map();
    cards.forEach((card) => {
      if (!events.has(card.dataset.communityStory)) {
        events.set(card.dataset.communityStory, card.dataset.communityEvent);
      }
    });
    events.forEach((label, value) => {
      const option = document.createElement('option');
      option.dataset.eventOption = '';
      option.value = value;
      option.textContent = label;
      filter.append(option);
    });

    const initialEvent = new URL(window.location.href).searchParams.get('event');
    if (initialEvent && events.has(initialEvent)) filter.value = initialEvent;
    const controller = new AbortController();
    const apply = () => {
      const selected = filter.value;
      let visible = 0;
      cards.forEach((card) => {
        const show = selected === 'all' || card.dataset.communityStory === selected;
        card.hidden = !show;
        if (show) visible += 1;
      });
      status.textContent = `Showing ${visible} archive ${visible === 1 ? 'item' : 'items'}.`;
    };
    filter.addEventListener('change', () => {
      apply();
      const url = new URL(window.location.href);
      if (filter.value === 'all') url.searchParams.delete('event');
      else url.searchParams.set('event', filter.value);
      window.history.replaceState(window.history.state, '', url);
    }, { signal: controller.signal });
    controls.hidden = false;
    states.set(root, { controller });
    apply();
  }

  function destroy(root) {
    const state = states.get(root);
    if (!state) return;
    state.controller.abort();
    states.delete(root);
  }

  function initWithin(scope) { rootsWithin(scope).forEach(init); }
  function destroyWithin(scope) { rootsWithin(scope).forEach(destroy); }

  window.ArmorCommunityV2 = { initWithin, destroyWithin };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document), { once: true });
  } else {
    initWithin(document);
  }
  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));
})();
